"use strict";

import {
    default as React,
    Component,
} from 'react';
import PropTypes from 'prop-types';

import ReactDOM from 'react-dom';

import * as D3Axis from 'd3-axis';
import * as D3Selection from 'd3-selection'
import ReactFauxDOM from 'react-faux-dom';
import {scale} from '../utils/scale';

export default class Axis extends Component {
    constructor (props) {
        super(props);
    }

    static defaultProps = {
        range: null,
        domain: null,
    };

    static propTypes = {
        type: PropTypes.string,
        tickConfig: PropTypes.shape({
            sizeInner: PropTypes.number,
            sizeOuter: PropTypes.number,
            values: PropTypes.oneOfType([PropTypes.array, PropTypes.func]),
            format: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
            count: PropTypes.number,
            padding: PropTypes.number,
            orient: PropTypes.oneOf(['top', 'bottom', 'left', 'right']),
            className: PropTypes.string,
        }),
        customStyle: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
        orient: PropTypes.string,
    };

    // componentDidMount() {
    //     let tickSize = [];
    //     let maxSize;
    //
    //     let { padding, sizeInner, sizeOuter } = this.props.tickConfig;
    //     let excess = padding + Math.max(Math.abs(sizeInner), Math.abs(sizeOuter)) +5;
    //     let parent = ReactDOM.findDOMNode(this).parentNode.parentNode.parentNode.parentNode;
    //
    //     // let {width, height} = this.props;
    //
    //     // if (this.props.type === 'x') {
    //     //
    //     //     D3Selection.selectAll('.xAxis .tick text')
    //     //         .each(function() {tickSize.push(this.getBoundingClientRect().height); })
    //     //         .remove();
    //     //
    //     //     if(tickSize.length > 0) {}
    //     //     maxSize = Math.max(...tickSize) | 0;
    //     //
    //     //     if (this.props.orient === 'top' && this.props.tickConfig.orient === 'bottom' ) {
    //     //         let scalingFactor = (height - maxSize - excess)/height;
    //     //
    //     //         Array.from(parent.querySelectorAll('.x-grid-axis')).forEach( (el) => {
    //     //             el.setAttribute('transform', `scale(${scalingFactor}, 1)`);
    //     //             el.setAttribute('transform', `translate(0, ${excess+maxSize})`);
    //     //
    //     //             return el;
    //     //         });
    //     //
    //     //         Array.from(parent.querySelectorAll('.yAxis')).forEach( (el) => {
    //     //             el.setAttribute('transform', `scale(${scalingFactor}, 1)`);
    //     //             el.setAttribute('transform', `translate(0, ${excess+maxSize})`);
    //     //
    //     //             return el;
    //     //         });
    //     //
    //     //         Array.from(parent.querySelectorAll('path')).forEach( (el) => {
    //     //             el.setAttribute('transform', `scale(${scalingFactor}, 1)`);
    //     //             el.setAttribute('transform', `translate(0, ${excess+maxSize})`);
    //     //
    //     //             return el;
    //     //         });
    //     //     } else if (this.props.orient === 'bottom' && this.props.tickConfig.orient === 'top' ) {
    //     //         let scalingFactor = (height - maxSize - excess)/height;
    //     //
    //     //         Array.from(parent.querySelectorAll('.x-grid-axis')).forEach( (el) => {
    //     //             el.setAttribute('transform', `scale(1, ${scalingFactor})`);
    //     //
    //     //             return el;
    //     //         });
    //     //
    //     //         Array.from(parent.querySelectorAll('.yAxis')).forEach( (el) => {
    //     //             el.setAttribute('transform', `scale(1, ${scalingFactor})`);
    //     //
    //     //             return el;
    //     //         });
    //     //
    //     //         Array.from(parent.querySelectorAll('path')).forEach( (el) => {
    //     //             el.setAttribute('transform', `scale(1, ${scalingFactor})`);
    //     //
    //     //             return el;
    //     //         });
    //     //     }
    //     //
    //     //
    //     // }
    //
    //     let width = parent.parentNode.getBoundingClientRect().width;
    //
    //     if (this.props.type === 'y') {
    //         let test = D3Selection.selectAll('.yAxis .tick text')
    //             .each(function() {tickSize.push(this.getBoundingClientRect().width); })
    //             .remove();
    //
    //         if(tickSize.length > 0) {}
    //         maxSize = Math.max(...tickSize);
    //
    //         if (this.props.orient === 'left' && this.props.tickConfig.orient === 'right' &&
    //             excess > 0) {
    //             // let scalingFactor = (width - maxSize - excess)/width;
    //             //
    //             // Array.from(parent.querySelectorAll('.y-grid-axis')).forEach( (el) => {
    //             //     el.setAttribute('transform', `scale(${scalingFactor}, 1)`);
    //             //     el.setAttribute('transform', `translate(${excess+maxSize}, ${0})`);
    //             //
    //             //     return el;
    //             // });
    //             //
    //             // Array.from(parent.querySelectorAll('.xAxis')).forEach( (el) => {
    //             //     el.setAttribute('transform', `scale(${scalingFactor}, 1)`);
    //             //     el.setAttribute('transform', `translate(${excess + maxSize}, ${0})`);
    //             //
    //             //     return el;
    //             // });
    //             //
    //             // Array.from(parent.querySelectorAll('path')).forEach( (el) => {
    //             //     el.setAttribute('transform', `scale(${scalingFactor}, 1)`);
    //             //     el.setAttribute('transform', `translate(${excess + maxSize}, ${0})`);
    //             //
    //             //     return el;
    //             // });
    //
    //         } else if (this.props.orient === 'right' && this.props.tickConfig.orient === 'left' &&
    //             excess > 0) {
    //             let scalingFactor = (width - maxSize - excess)/width;
    //
    //             scalingFactor = 1;
    //
    //             Array.from(parent.querySelectorAll('.y-grid-axis')).forEach( (el) => (
    //                 el.parentNode.setAttribute('transform', `scale(${scalingFactor}, 1)`)
    //             ));
    //
    //             Array.from(parent.querySelectorAll('.xAxis')).forEach( (el) => {
    //                 // el.parentNode.setAttribute('transform', `scale(${scalingFactor}, 1)`)
    //                 el.setAttribute('transform', `scale(${scalingFactor}, 1)`)
    //             });
    //
    //             Array.from(parent.querySelectorAll('.line')).forEach( (el) => {
    //                 let oldTransform = el.parentNode.getAttribute('transform') ?
    //                     el.parentNode.getAttribute('transform') : '';
    //
    //                 el.parentNode.setAttribute('transform', `scale(${scalingFactor}, 1)`)
    //             });
    //
    //             Array.from(parent.querySelectorAll('.yAxis')).forEach( (el) => {
    //                 let oldTransform = el.parentNode.getAttribute('transform') == 0 ? ''
    //                     : el.parentNode.getAttribute('transform');
    //
    //                 // el.setAttribute('transform', `translate(${-(maxSize)}, ${0})`)
    //                 // el.setAttribute('transform', `translate(${-25-(excess + maxSize)}, ${0})`)
    //             });
    //         }
    //     }
    //
    //
    // }

    _mkTickAxis () {
        const {
            scaleSet,
            tickConfig,
        } = this.props;

        const {
            sizeInner,
            sizeOuter,
            values,
            format,
            count,
            padding,
            orient,
        } = tickConfig;



        let func = D3Axis;


        if(orient === 'left') {
            func = func.axisLeft(scaleSet);
        }else if (orient === 'right') {
            func = func.axisRight(scaleSet)
        }else if (orient === 'top') {
            func = func.axisTop(scaleSet)
        }else if (orient === 'bottom') {
            func = func.axisBottom(scaleSet)
        }

        if(format)
            func.tickFormat(format);

        if(Number.isFinite(padding))
            func.tickPadding(padding);

        if(Number.isFinite(sizeOuter))
            func.tickSizeOuter(sizeOuter);

        if(Number.isFinite(sizeInner))
            func.tickSizeInner(sizeInner);

        if(typeof values === 'function' )
            func.tickValues(values( scaleSet ));

        if( values && values.constructor === Array ) {
            func.tickValues(values);
        }

        if(Number.isFinite(count))
            func.ticks(count);

        return func;

    }

    render () {

        const {
            showAxis,
            axisClassName,
            type,
            style,
            tickConfig,
            customStyle,
        } = this.props;

        let axisGroup = ReactFauxDOM.createElement('g');

        let axisClasses;
        if(type === 'x')
            axisClasses = `${axisClassName} axis x`;
        else if(type === 'y')
            axisClasses = `${axisClassName} axis y`;
        else if(type === 'gridx' || type === 'gridy')
            axisClasses = `${axisClassName} grid-axis`;

        axisGroup.setAttribute('class', axisClasses);

        let axisDom = D3Selection.select(axisGroup);

        axisDom.call(this._mkTickAxis());
        axisDom.selectAll(".xAxis .tick text")
            .each(function(d) {
                // d.width = this.getBBox().width;
            })
            .attr("width", function(d) { return d; });



        if(!showAxis) {
            axisDom.selectAll(".grid-axis .tick text")
                .style("opacity", "0")

            if(type === 'gridx' || type === 'gridy') {
                // hide domain in grids
                axisDom.selectAll(".grid-axis .domain")
                    .style("opacity", "0")
            }
        }

        const axisPath = axisDom.selectAll('.axis path');
        axisPath
            .style('fill', 'none')
            .style('stroke', '#000')
            .style('shape-rendering', 'crispEdges');

        customStyle ? Object.keys(customStyle).map(function(_) {
                axisPath.style(_,customStyle[_]);
            }) : null;

        // apply user defined style for axis tick line if provided or else default
        if(tickConfig.tickClassName) {
            let axisLine = axisDom.selectAll('.axis line');
            axisLine.attr("class", tickConfig.tickClassName);
        }
        else
            axisDom.selectAll('.axis line')
                .style('fill', 'none')
                .style('stroke', '#000')
                .style('shape-rendering', 'crispEdges');

        // apply user defined style for grid axes if provided or else default
        let gridLine = null;
        if(type === 'gridx'){
            gridLine = axisDom.selectAll('.x-grid-axis line')
        }

        if(type === 'gridy'){
            gridLine = axisDom.selectAll('.y-grid-axis line')
        }

        if (gridLine && (type === 'gridx' || type === 'gridy')) {

            if (tickConfig.tickClassName) {
                gridLine.attr("class", tickConfig.tickClassName);
            } else {
                gridLine
                    .style('opacity', .2)
                    .style('fill', 'none')
                    .style('stroke', '#000')
                    .style('stroke-width', '1.5px');
            }
            gridLine.filter( d => d === 100 ).classed("zero-gridline", true);

            customStyle ? Object.keys(customStyle).map(function(_) {
                    gridLine.style(_,customStyle[_]);
                }) : null;

            let tickGroups = axisDom.selectAll('.y-grid-axis .tick');
            // tickGroups._groups.map(tickGroup => {
            //    tickGroup.attr('class', tickConfig.tickClassName )
            // });
        }

        // Axis tick label selection
        let axisTickLabel = axisDom.selectAll('.axis .tick text');

        // user defined style for tick labels
        if(tickConfig.tickLabelClassName) {
            axisTickLabel.attr("class", tickConfig.tickLabelClassName);
        }

        // User-defined styles applied by a function
        tickConfig.customTickLabelStyle ? Object.keys(tickConfig.customTickLabelStyle).map(function(_) {
                axisTickLabel.style(_, tickConfig.customTickLabelStyle[_]);
            }) : null;

        return axisDom.node().toReact();
    }
}
